/* global mainScript */
import React, { useContext } from "react";

import { locationShape } from "../Types";

import MapContext from "../context/MapContext";

// each item on the menu of the selected category
// need some conditional logic to render the pin-icon because it might have a number in it or it might have an icon inside (ATM, info, washroom...)

const CategoryListItem = (props) => {
	const { option } = props;

	const {
		data: { selectedLocation, highlightedMenuItem, showPopout, isNewFood },
		actions: { handleHoverMenuItem, handleClickMenuItem },
	} = useContext(MapContext);

	const renderIcon = () => {
		// display could be a number in which case it will display a number or it could be a string which will display an icon
		const isNumber = Number.isInteger(+option.display);
		const displayNumber = isNumber && option.display;
		const displayIcon = !isNumber && option.display;
		const classes = `filter-bar__category__list__item__icon--${
			isNumber ? "number" : "icon " + "icon-" + option.display
		}`;
		if(displayIcon) {
			return <img
				className={classes}
				src={
					mainScript.assetPath +
				`images/svg/icons/icon-${option.display}.svg`
				}
			/>
		} else {
			return <span className={classes}>{displayNumber}</span>;
		}
	};

	const handleClick = () => {
		handleClickMenuItem(option);
	};

	const handleHover = (location = null) => {
		if (selectedLocation && selectedLocation.name === option.name) {
			return;
		}
		handleHoverMenuItem(location);
	};

	const events = {
		onClick: () => handleClick(),
		onMouseEnter: () => handleHover(option.name),
		onMouseLeave: () => handleHover(),
		onFocus: () => handleHover(option.name),
		onBlur: () => handleHover(),
	};

	const isHighlighted =
		highlightedMenuItem === option?.name ||
		(selectedLocation && selectedLocation.name === option.name && showPopout);

	return (
		<button
			{...events}
			className={`filter-bar__category__list__item ${
				isHighlighted ? "highlight" : ""
			}`}
		>
			{!isNewFood && renderIcon()}
			<span
				className="filter-bar__category__list__item__title"
				dangerouslySetInnerHTML={{ __html: option.name }}
			/>
		</button>
	);
};

CategoryListItem.propTypes = {
	option: locationShape,
};

export default CategoryListItem;
